module.exports = __webpack_public_path__ + "img/handshake.2db2448.png";